import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=4d74592a&scoped=true"
import script from "./OrderInfo.vue?vue&type=script&lang=js"
export * from "./OrderInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderInfo.vue?vue&type=style&index=0&id=4d74592a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d74592a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d74592a')) {
      api.createRecord('4d74592a', component.options)
    } else {
      api.reload('4d74592a', component.options)
    }
    module.hot.accept("./OrderInfo.vue?vue&type=template&id=4d74592a&scoped=true", function () {
      api.rerender('4d74592a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/sepecialOrderPrint/components/OrderInfo.vue"
export default component.exports